import { React, useState } from "react";
import Button from "react-bootstrap/Button";
import { useHistory } from "react-router-dom";
import Modal from "react-bootstrap/Modal";

const ConfirmAlertModal = (props) => {
  const history = useHistory;
  let formName = props.formName;
  const closeTab = () => {
    window.close();
  };

  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button> */}

      <Modal
        className="confirmAlertModal"
        show={props.show}
        onHide={props.handleClose}
        animation={false}
        backdrop="static"
      >
        <br></br>
        <Modal.Body className="confirmcss">
          {props.message ? <>{props.message} </> : `Are you sure you want to ${props.action ? props.action : ""} ${formName} ${props.module ? props.module : ""} ?`}
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button variant="primary" onClick={async () => await props.handleYes()}>
            Yes
          </Button>
          <Button variant="outline-primary" onClick={() => props.handleClose()}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmAlertModal;
